// extracted by mini-css-extract-plugin
module.exports = {"sloganColor":"#515151","whyUsBriefColor":"#747474"};